import { AxiosRequestConfig } from 'axios'
import { ReactNode } from 'react'
import { observable } from 'mobx'
import { http, IMenuItem } from '@ud/admin-framework'
import { ITokenData, IMyUserData } from '../typings'

class AppStore {
  public myUserData: IMyUserData = null as any
  public uaaAppName: string = ''
  public uaaMenus: IMenuItem[] = []
  public uaaRouteNodes: ReactNode[] = []

  @observable
  public currentSystemCode: string = ''
  @observable
  public showCenterHeader: boolean = true
  @observable
  public showCenterSidebar: boolean = true
  /** 侧边栏是否激活，仅在移动端时有用 */
  @observable
  public centerSidebarActive = false

  public setToken(token: ITokenData) {
    localStorage.setItem('uaa_token', JSON.stringify(token))
    sessionStorage.setItem('Authorization', JSON.stringify(token))
  }

  public getToken(): ITokenData | null {
    let tokenJson = localStorage.getItem('uaa_token')
    if (tokenJson) {
      return JSON.parse(tokenJson) as ITokenData
    }
    return null
  }

  public getSystem(code: string) {
    return this.myUserData.generalMenus.find(n => n.customId == code)
  }

  public removeToekn() {
    localStorage.removeItem('uaa_token')
  }

  public logout() {
    this.removeToekn()
    sessionStorage.removeItem('uaa_last_visit_url')
    let config: AxiosRequestConfig = {
      withCredentials: true
    }
    if (process.env.NODE_ENV == 'development') {
      config.useBizErrorHandler = false
      config.useSysErrorHandler = false
    }
    http.get('/logout', config).finally(() => {
      window.location.href = './index.html'
    })
  }

}

let appStore = new AppStore()

export { appStore }
